import {
    GET_CATALOG_ITEM,
    GET_CATALOG_SPECIFICATION_BY_SUBTYPE,
    GET_IS_CATALOG_ITEM_VALID_DELETE,
    SET_CATALOG_ITEM,
    SET_CATALOG_SPECIFICATION_BY_SUBTYPE,
    SET_IS_CATALOG_ITEM_VALID_DELETE,
    GET_IS_VEHICLE_LEVEL_VALID_DELETE,
    SET_IS_VEHICLE_LEVEL_VALID_DELETE,
    GET_IS_EQ_CLASS_VALID_DELETE,
    SET_IS_EQ_CLASS_VALID_DELETE,
    GET_SAVE_MULTIPLE_CATALOG_STATUS,
    SET_SAVE_MULTIPLE_CATALOG_STATUS
} from "./CatalogItemType"

const getCatalogItem = (filterValues: number) => {
    return ({
        type: GET_CATALOG_ITEM,
        filterValues: filterValues
    })
};

const setCatalogItem = (catalogItem: any) => ({
    type: SET_CATALOG_ITEM,
    catalogItem: catalogItem
});

const getCatalogSpecificationBySubType = (requestDetailId: any, fleetId: any, isBulkOrder: boolean) => {
    return ({
        type: GET_CATALOG_SPECIFICATION_BY_SUBTYPE,
        requestDetailId,
        fleetId,
        isBulkOrder
    })
};

const setCatalogSpecificationBySubType = (catalogItem: any) => ({
    type: SET_CATALOG_SPECIFICATION_BY_SUBTYPE,
    catalogItem: catalogItem
});

const getIsCatalogItemValidDelete = (payload: any) => ({
    type: GET_IS_CATALOG_ITEM_VALID_DELETE,
    payload
});

const setIsCatalogItemValidDelete = (isCatalogItemValidForDelete: any) => ({
    type: SET_IS_CATALOG_ITEM_VALID_DELETE,
    isCatalogItemValidForDelete: isCatalogItemValidForDelete
});

const getIsVehicleLevelValidDelete = (payload: any) => ({
    type: GET_IS_VEHICLE_LEVEL_VALID_DELETE,
    payload
});

const setIsVehicleLevelValidDelete = (isVehicleLevelValidForDelete: any) => ({
    type: SET_IS_VEHICLE_LEVEL_VALID_DELETE,
    isVehicleLevelValidForDelete: isVehicleLevelValidForDelete
});

const getIsEqClassValidDelete = (payload: any) => ({
    type: GET_IS_EQ_CLASS_VALID_DELETE,
    payload
});

const setIsEqClassValidDelete = (isEqClassValidForDelete: any) => ({
    type: SET_IS_EQ_CLASS_VALID_DELETE,
    isEqClassValidForDelete: isEqClassValidForDelete
});

const getSaveMultipleCatalogStatus = (payload: any) => ({
    type: GET_SAVE_MULTIPLE_CATALOG_STATUS,
    payload
});

const setSaveMultipleCatalogStatus = (isSavedMultipleCatalogStatus: any) => ({
    type: SET_SAVE_MULTIPLE_CATALOG_STATUS,
    isSavedMultipleCatalogStatus: isSavedMultipleCatalogStatus
});

export {
    getCatalogItem,
    setCatalogItem,
    getCatalogSpecificationBySubType,
    setCatalogSpecificationBySubType,
    getIsCatalogItemValidDelete,
    setIsCatalogItemValidDelete,
    getIsVehicleLevelValidDelete,
    setIsVehicleLevelValidDelete,
    getIsEqClassValidDelete,
    setIsEqClassValidDelete,
    getSaveMultipleCatalogStatus,
    setSaveMultipleCatalogStatus
}